import React from 'react';
import FitnessProfileQuestionnairePage from './FitnessProfileQuestionnairePage';

export default function FitnessProfileCompleteIntakePage() {
	return <FitnessProfileQuestionnairePage mode="complete" />;
}
